import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Contact Model
import VuexORM from '@vuex-orm/core';
var ConstructionContactAgent = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(ConstructionContactAgent, _VuexORM$Model);
  var _super = _createSuper(ConstructionContactAgent);
  function ConstructionContactAgent() {
    _classCallCheck(this, ConstructionContactAgent);
    return _super.apply(this, arguments);
  }
  _createClass(ConstructionContactAgent, null, [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'construction_contact_agents';
    }
  }, {
    key: "fields",
    value:
    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        construction_id: this.attr(null),
        contact_agent_id: this.attr(null)
      };
    }
  }]);
  return ConstructionContactAgent;
}(VuexORM.Model);
_defineProperty(ConstructionContactAgent, "primaryKey", ['construction_id', 'contact_agent_id']);
export { ConstructionContactAgent as default };